import { Outlet } from "react-router-dom";

type Props = {};

const Patient = (props: Props) => {
  return <Outlet />;
};

export default Patient;
